import React from "react";
import CustomDropdown from "../common/CustomDropdown";
import { FaFileExcel } from "react-icons/fa";

const DesktopFiltersBar = ({
  searchTerm,
  onSearchChange,
  sortBy,
  onSortChange,
  onExport,
  exportingData,
  disabled,
  onAgentFilterClick,
  onPositionFilterClick,
  agentFilterText,
  positionFilterText,
}) => {
  return (
    <div className="flex flex-wrap gap-4 px-12 py-4 border-b border-[#E5E6E8] mb-6 items-center justify-between">
      <div className="flex gap-3">
        <div className="relative">
          <button
            onClick={onAgentFilterClick}
            className="border border-[#D2D4D8] rounded-lg px-4 py-2 text-[16px] font-medium bg-white hover:bg-gray-50"
          >
            Applied by: {agentFilterText}
          </button>
        </div>

        <div className="relative">
          <button
            onClick={onPositionFilterClick}
            className="border border-[#D2D4D8] rounded-lg px-4 py-2 text-[16px] font-medium bg-white hover:bg-gray-50"
          >
            Filter by positions: {positionFilterText}
          </button>
        </div>
      </div>

      <div className="flex gap-3">
        <div className="flex items-center border border-[#D2D4D8] rounded-lg px-4 py-2 bg-white">
          <span className="mr-2 text-gray-400">
            <svg width="18" height="18" fill="none" viewBox="0 0 18 18">
              <circle
                cx="8.5"
                cy="8.5"
                r="7.5"
                stroke="#BDBDBD"
                strokeWidth="2"
              />
              <path
                d="M16 16L13.5 13.5"
                stroke="#BDBDBD"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </span>
          <input
            className="outline-none border-none bg-transparent text-[16px] font-medium w-32"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
        <div className="min-w-[100px]">
          <CustomDropdown
            options={[
              { value: "latest", label: "Latest" },
              { value: "oldest", label: "Oldest" },
            ]}
            value={sortBy}
            onChange={onSortChange}
            placeholder="Latest"
            className="border border-[#D2D4D8] rounded-lg px-4 py-2 text-[16px] font-medium"
          />
        </div>
        <button
          onClick={onExport}
          disabled={exportingData || disabled}
          className="flex items-center gap-2 px-4 py-2 bg-[#2283FF] text-white text-sm rounded-lg hover:bg-green-600 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {exportingData ? (
            <>
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              Exporting...
            </>
          ) : (
            <>
              <FaFileExcel className="w-4 h-4" />
              Export to Excel
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default DesktopFiltersBar;
